module.exports = __webpack_public_path__ + "img/google-calendar.2d958f49.jpeg";